import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export default function DialogConfirmacaoRessuprimento({ open, onConfirm, onCancel }: DialogConfirmacaoRessuprimentoProps) {
  return (
    <Dialog open={open}>
      <DialogTitle>Confirmação</DialogTitle>
      <DialogContent>
        <DialogContentText>Nenhum item foi selecionado. Deseja continuar?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()} variant="outlined">
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

interface DialogConfirmacaoRessuprimentoProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}